export default {"src":"/_next/static/media/minus.da3ea699.svg","height":32,"width":18,"blurWidth":0,"blurHeight":0};